import { ManufacturersWarrantyType } from '../../api-client/autogenerated';

/**
 * How a bidder gave CENTERLINE the Substitution Request form: filled it in on the portal, or
 * uploaded one they completed elsewhere. Nothing below the description renders until they pick.
 */
export type SubstitutionRequestEntryMode = 'FORM' | 'UPLOAD';

/** Everything the bidding portal's Add Substitution Request dialog can collect. */
export type SubstitutionRequestDraft = {
  /** Asked on both paths, so it is never enough on its own. */
  description: string;
  entryMode?: SubstitutionRequestEntryMode;
  hasFile: boolean;
  submittalSection: string;
  submittalSectionError: boolean;
  pageNumber?: number;
  paragraphNumber?: number;
  proposedSubstitution: string;
  substitutionReason: string;
  waysAffectingDrawings: string;
  affectsOtherTrades: string;
  agencyApproval: string;
  differences: string;
  manufacturersWarranties?: ManufacturersWarrantyType;
  explanation: string;
  availabilityInfo: string;
};

/**
 * Whether the request is complete enough to submit.
 *
 * The description is required either way -- it is what the substitution log and the architect see
 * first. Beyond that the two paths ask for different things: filling the form in on the portal
 * means every field of it, and uploading a completed form means the file itself.
 */
export const canSubmitSubstitutionRequest = (draft: SubstitutionRequestDraft): boolean => {
  if (!draft.description.trim() || !draft.entryMode) return false;
  if (draft.entryMode === 'UPLOAD') return draft.hasFile;
  return (
    !!draft.submittalSection.trim() &&
    !draft.submittalSectionError &&
    draft.pageNumber != null &&
    draft.paragraphNumber != null &&
    !!draft.proposedSubstitution.trim() &&
    !!draft.substitutionReason.trim() &&
    !!draft.waysAffectingDrawings.trim() &&
    !!draft.affectsOtherTrades.trim() &&
    !!draft.agencyApproval.trim() &&
    !!draft.differences.trim() &&
    !!draft.manufacturersWarranties &&
    !!draft.explanation.trim() &&
    !!draft.availabilityInfo.trim()
  );
};
